import { useState, useEffect } from 'react';

/* Тёмная/светлая тема контента.
   По умолчанию тёмная: светлая включается, только если пользователь сам её
   выбрал (в localStorage лежит 'light'). Тот же выбор читает ранний скрипт
   в public/index.html — чтобы не мигало светлым до старта React.
   Сайдбар всегда графитовый — тема меняет только рабочую область. */
export default function useTheme() {
  const [dark, setDark] = useState(() => localStorage.getItem('theme') !== 'light');

  useEffect(() => {
    document.body.classList.toggle('dark', dark);
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  return { dark, toggle: () => setDark(d => !d) };
}
